import { DEFAULT_SECTIONS, ProductTypeConfig } from '../types';

/**
 * 1310 – Outperformance Certificate
 *
 * At a Glance: No coupon, shows Upside, Upside participation, Downside, Downside participation, Cap Level, Max Return, Strike level
 * Barrier: Disabled (no barrier for this product)
 * Underlyings: No barrier level/distance
 * Coupons: Disabled
 * Early Redemption: Disabled
 */
export const config1310: ProductTypeConfig = {
  code: '1310',
  name: 'Outperformance Certificate',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false, // No coupon
        upside: true, // Basket Type up
        upsideParticipation: true, // Participation up %
        downside: true, // Basket type down
        downsideParticipation: true, // Participation down %
        capLevel: true, // Cap Level (%)
        maxReturn: true, // Max. Return (%)
        strikeLevel: true, // Strike level
        issuePricePct: false,
        settlementType: true,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: false, // No barrier section
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        barrierLevel: false, // No barrier level
        barrierDistance: false, // No barrier distance
      },
    },

    coupons: {
      enabled: false, // No coupons
      props: {},
    },

    earlyRedemption: {
      enabled: false, // No early redemption
      props: {},
    },

    performance: {
      enabled: true,
      props: {},
    },

    couponDetails: {
      enabled: false, // No coupon details
      props: {},
    },
  },
};
